<script>
  import { onMount } from "svelte"
  import { auth, db, fstore, firebaseFunctions } from "../etc/firebase.js"
  import "materialize-css"
  import {
    userStore,
    userGuaCount,
    guaRecordStore,
    selectedLanguage,
    // newsListStore,
  } from "../etc/store.js"

  let subscriptionBeginOn = ""
  let subscriptionExpireOn = ""
  let firebaseUid = ""
  let createdDT = 0
  let userName = ""
  let userAlias = ""
  let country = ""
  let city = ""
  let phone = ""
  let email = ""
  let password = ""
  let transactionRecords = []
  let lastPayment = 0
  let currencyType = "USD$"
  let memberType = "unknown"
  let confirmPassword = ""
  let qiMonthlyGoal = 10
  let timeToExpiration = 0
  let showLoggedInElements = true
  let isAdmin = false
  let isLogin = false
  let isExpired = true
  let showExpirationWarning = false
  let showPasswd = false
  let toggleChineseStyle = false
  // onMount(async () => {
  document.addEventListener("DOMContentLoaded", function () {
    var modals = document.querySelectorAll(".modal")
    M.Modal.init(modals)

    // var items = document.querySelectorAll(".collapsible")
    // M.Collapsible.init(items)
  })

  $: if (toggleChineseStyle == true) {
    $selectedLanguage = "CN"
    // console.log("@ Nav.language selected = ", $selectedLanguage)
  } else {
    $selectedLanguage = "TW"
    // console.log("@ Nav.language selected = ", $selectedLanguage)
  }

  const setupUI = (user) => {
    if (user) {
      // console.log(
      //   "@ Nav.after login: $newsListStore = ",
      //   JSON.parse($newsListStore)
      // )
      // console.log("@ Nav.setupUI - Setting up Nav elements for " + user.email)
      if (isExpired == true) {
        // console.log("@ Nav: user login but expired")
        showLoggedInElements = false
        showExpirationWarning = true
      } else {
        showLoggedInElements = true
        showExpirationWarning = false
      }

      // console.log(
      //   "@ Nav.setupUI - All good. Done setting up Nav elements for " +
      //     user.email
      // )
    } else {
      //console.log("Cleaning up Nav elements...")
      showLoggedInElements = false
      showExpirationWarning = false
    }
  }

  // Listen for auth status change
  let userObj = {}
  let guaCount = 0
  let isFakeAccount = true
  let myFakeAccounts = [
    "alpha@xiyi.io",
    "beta@xiyi.io",
    "public@xiyi.io",
    "tester@xiyi.io",
  ]
  auth.onAuthStateChanged((user) => {
    if (user) {
      // console.log(
      //   "@ Nav.onAuthStateChanged - user just logged in 1st user check: ",
      //   user.email
      // )

      // let my fake accounts pass to fully login
      if (myFakeAccounts.includes(user.email)) {
        isFakeAccount = true
      } else {
        isFakeAccount = false
      }

      if (user.emailVerified != true && isFakeAccount != true) {
        user.sendEmailVerification().then(
          function () {
            //   console.log("@ Nav.signup - Email verification sent!")
            alert(
              "請查看您的電子郵件信箱，打開由【XiYi習易網】寄給您的email。請儘快確認您的email，您的帳號生效之後，才可以登入。"
            )
          },
          function (error) {
            console.log("@ Nav.signup - Error: not send Verification")
          }
        )
      } else {
        // Only verified email account can proceed.
        // console.log(
        //   "@ Nav.onAuthStateChanged: user email verified and in now fully logged in!"
        // )
        db.collection("xiyiMembers")
          .where("firebaseUid", "==", user.uid)
          .get()
          .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
              //console.log(doc.id, " => ", doc.data())
              userObj = {
                docId: doc.id,
                firebaseUid: user.uid,
                createdDT: doc.data().createdDT,
                userName: doc.data().userName,
                userAlias: doc.data().userAlias,
                email: doc.data().email,
                country: doc.data().country,
                city: doc.data().city,
                phone: doc.data().phone,
                paymentIntent: doc.data().paymentIntent,
                subscriptionBeginOn: doc.data().subscriptionBeginOn,
                subscriptionExpireOn: doc.data().subscriptionExpireOn,
                lastPayment: doc.data().lastPayment,
                currencyType: doc.data().currencyType,
                qiMonthlyGoal: doc.data().qiMonthlyGoal,
                memberType: doc.data().memberType,
                transactionRecords: doc.data().transactionRecords,
                timeToExpiration:
                  (doc.data().subscriptionExpireOn - new Date().getTime()) /
                  (1000 * 60 * 60 * 24),
                loginCounter: doc.data().loginCounter,
              }
            })

            $userStore.userInfo = userObj
            // console.log(
            //   "@ Nav.onAuthStateChanged just updated $userStore.userInfo = ",
            //   $userStore.userInfo
            // )

            // console.log("@ Nav: timeToExpiration = " + timeToExpiration)
            if (timeToExpiration >= 0) {
              isExpired = false
              isLogin = true
              $userStore.isExpired = false
              $userStore.isLogin = true
            } else {
              isExpired = true
              isLogin = true
              $userStore.isExpired = true
              $userStore.isLogin = true
            }

            //If admin, show the xiyiadmin page
            if (userObj.memberType == "admin") {
              isAdmin = true
            } else {
              isAdmin = false
            }

            setupUI(user)

            // console.log(
            //   "@ Nav.onAuthStateChanged done updating all for $userStore.userInfo.userName = ",
            //   $userStore.userInfo.userName
            // )
          })
          .catch((error) => {
            console.log("@ Nav: Error getting XiYiMembers documents: ", error)
          })

        // // console.log("@ Nav: timeToExpiration = " + timeToExpiration)
        // if (timeToExpiration >= 0) {
        //   isExpired = false
        //   isLogin = true
        //   $userStore.isExpired = false
        //   $userStore.isLogin = true
        // } else {
        //   isExpired = true
        //   isLogin = true
        //   $userStore.isExpired = true
        //   $userStore.isLogin = true
        // }

        // setupUI(user)
      }
    } else {
      // loadNews()
      setupUI()
      isLogin = false
      isExpired = true
    }
  })

  // signup
  let dangerField = true
  let dangerFieldClass = ""
  $: password == confirmPassword ? (dangerField = false) : (dangerField = true)
  $: dangerField ? (dangerFieldClass = "danger-field") : (dangerFieldClass = "")

  function cleanInputs() {
    if (dangerField) {
      return false
    } else {
      return true
    }
  }

  // Alpha period sign up with 14 days testing period
  // Regular 7 days testing period.
  //  let freeTestPeriod = 7
  //  let freeTestPeriod = 14
  // 6/30/2021 11:59:59PM = 1625122799000
  let freeTestPeriod = (1625122799000 - Date.now()) / (24 * 60 * 60 * 1000)
  // console.log(
  //   "@ Nav: remaining days to 6/30/2021 11:59:59PM = ",
  //   freeTestPeriod
  // )

  // *********************
  // *** Handle Signup ***
  // *********************
  function handleSignup() {
    // firstly, check all inputs being valid before attemptig account creation
    if (cleanInputs()) {
      //alert("doing signup with email and password: " + email + ", " + password)
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((credential) => {
          //console.log(credential.user)
          // console.log("@ Nav User UID: ", credential.user.uid)

          // Saving other user info to xiyiMembers collection
          let firebaseUid = credential.user.uid
          createdDT = new Date().getTime()
          subscriptionBeginOn = createdDT
          // 7 days
          subscriptionExpireOn =
            createdDT + 24 * 60 * 60 * 1000 * freeTestPeriod

          let loginCounter = 0
          // db.collection("xiyiMembers")
          //   .add({
          //     createdDT,
          //     subscriptionBeginOn,
          //     subscriptionExpireOn,
          //     lastPayment,
          //     currencyType,
          //     firebaseUid,
          //     userName,
          //     userAlias,
          //     email,
          //     country,
          //     city,
          //     phone,
          //     qiMonthlyGoal,
          //     memberType,
          //     transactionRecords,
          //   })
          db.collection("xiyiMembers")
            .doc(firebaseUid)
            .set({
              createdDT,
              subscriptionBeginOn,
              subscriptionExpireOn,
              lastPayment,
              currencyType,
              firebaseUid,
              userName,
              userAlias,
              email,
              country,
              city,
              phone,
              qiMonthlyGoal,
              memberType,
              transactionRecords,
              loginCounter,
            })
            .then(() => {
              const modal_signup = document.querySelector("#modal-signup")
              M.Modal.getInstance(modal_signup).close()

              userName = ""
              userAlias = ""
              email = ""
              password = ""
              country = ""
              city = ""
              phone = ""
              confirmPassword = ""
            })
            .catch(function (error) {
              console.log(error)
            })

          //  signupForm.reset()

          //alert("You account is created!")
        })
        .catch(function (error) {
          console.log(error)
        })
    } else {
      alert("Password not matching! Please reconfirm password.")
      confirmPassword = ""
    }
  }

  // *********************
  // *** Handle Login ***
  // *********************
  function handleLogin() {
    auth
      .signInWithEmailAndPassword(email, password)
      .then((credential) => {
        //console.log(credential.user)
        //console.log("@ Nav.Login - Credential User UID: ", credential.user.uid)
        //console.log(
        //  "@ Nav.Login - Credential User email: ",
        //  credential.user.email
        // )

        // update logingCounter and related stat
        const increment = fstore.FieldValue.increment(1)
        db.collection("xiyiMembers")
          .doc(credential.user.uid)
          .update({
            loginCounter: increment,
          })
          .then(() => {
            // console.log(
            //   "@ Nav.handleLogin: increment loginCounter and ready to update localStorage."
            // )

            // Getting member info to localStorage
            db.collection("xiyiMembers")
              .where("firebaseUid", "==", credential.user.uid)
              .get()
              .then((querySnapshot) => {
                //console.log("@ Nav.Login - in xiyiMembers querySnapshot")

                querySnapshot.forEach((doc) => {
                  //console.log(doc.id, " => ", doc.data())
                  userObj = {
                    docId: doc.id,
                    firebaseUid: credential.user.uid,
                    createdDT: doc.data().createdDT,
                    userName: doc.data().userName,
                    userAlias: doc.data().userAlias,
                    email: doc.data().email,
                    country: doc.data().country,
                    city: doc.data().city,
                    phone: doc.data().phone,
                    paymentIntent: doc.data().paymentIntent,
                    subscriptionBeginOn: doc.data().subscriptionBeginOn,
                    subscriptionExpireOn: doc.data().subscriptionExpireOn,
                    lastPayment: doc.data().lastPayment,
                    currencyType: doc.data().currencyType,
                    qiMonthlyGoal: doc.data().qiMonthlyGoal,
                    memberType: doc.data().memberType,
                    transactionRecords: doc.data().transactionRecords,
                    timeToExpiration:
                      (doc.data().subscriptionExpireOn - new Date().getTime()) /
                      (1000 * 60 * 60 * 24),
                    loginCounter: doc.data().loginCounter + 1,
                  }
                })

                $userStore.userInfo = userObj
                // console.log(
                //   "@ Nav.xiyiMembers $userStore.userInfo = ",
                //   $userStore.userInfo
                // )

                // console.log("@ Nav: timeToExpiration = " + timeToExpiration)
                if (timeToExpiration >= 0) {
                  isExpired = false
                  isLogin = true
                  $userStore.isExpired = false
                  $userStore.isLogin = true
                } else {
                  isExpired = true
                  isLogin = true
                  $userStore.isExpired = true
                  $userStore.isLogin = true
                }

                // console.log(
                //   "@ Nav.Login: getting memberType in userObj: ",
                //   userObj.memberType
                // )
                if (userObj.memberType == "admin") {
                  isAdmin = true
                } else {
                  isAdmin = false
                }

                //setupUI(user)
              })
              .catch((error) => {
                console.log(
                  "@ Nav.Login: Error getting XiYiMembers documents: ",
                  error
                )
              })
          })
          .catch((error) => {
            console.log(error)
          })

        loadGuaRecords(credential.user.uid)
        // console.log(
        //   "@ Nav.Login: Done handling Login process for $userStore.userInfo.userName = ",
        //   $userStore.userInfo.userName
        // )
        email = ""
        password = ""
      })
      .catch((error) => {
        alert(
          "Password incorrect or account does not exist. Login for private use only."
        )
        const modal = document.querySelector("#modal-login")
        M.Modal.getInstance(modal).close()
      })
  }

  function loadGuaRecords(firebaseUid) {
    // console.log(
    //   "@ Nav.Login.loadGuaRecords - just got in guaRecords function for firebaseUid = ",
    //   firebaseUid
    // )
    let guaRecords = []
    db.collection("guaRecords")
      .where("firebaseUid", "==", firebaseUid)
      .get()
      .then((querySnapshot) => {
        // console.log("@ Nav.Login.loadGuaRecords - in guaRecords querySnapshot")
        guaCount = 0
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          guaCount++
          let tmpArray = doc.data()
          tmpArray.show = true
          tmpArray.id = doc.id
          guaRecords.push(tmpArray)
        })
        // sort the guaRecords per recordDT as default sort.
        // console.log(
        //   "@ Nav.login.processing guaRecords: before sort guaRecords = ",
        //   guaRecords
        // )
        guaRecords.sort((a, b) => (a.recordDT < b.recordDT ? 1 : -1))
        // console.log(
        //   "@ Nav.login.processing guaRecords: after sort guaRecords = ",
        //   guaRecords
        // )

        // $userStore.guaCount = guaCount
        //$userStore.guaRecords = [...guaRecords]
        if (guaRecords.length != 0) {
          $guaRecordStore = JSON.stringify(guaRecords)
          $userGuaCount = guaCount
          // console.log(
          //   "@ Nav.Login.loadGuaRecords: +++ the refreshed JSON.parse($guaRecordStore) = ",
          //   JSON.parse($guaRecordStore)
          // )
        } else {
          // console.log(
          //   "@ Nav.Login.loadGuaRecords: currently there is no guaRecords for firebaseUid = ",
          //   firebaseUid
          // )
        }

        const modal_login = document.querySelector("#modal-login")
        M.Modal.getInstance(modal_login).close()
      })
      .catch(function (error) {
        console.log("@ Nav: Error getting guaRecords documents: ", error)
      })
  }

  // logout
  //const logoutForm = document.querySelector("#logout")
  function handleLogout() {
    //alert("doing logout for email: " + email )
    auth.signOut().then(() => {
      showLoggedInElements = false
      isAdmin = false
      isLogin = false
      isExpired = true
      $userStore.isAdmin = false
      $userStore.isLogin = false
      $userStore.isExpired = true
      $userStore.isNextDay = false
      $userStore.userInfo = {}
      $guaRecordStore = []
      $userGuaCount = 0
    })
  }

  let showVerticalMenu = false
  let showBurger = true
  let mobileClickCounter = 0
  function showMobileMenu() {
    // alert("Show the verticle menu for mobile devices")
    //showVerticalMenu = !showVerticalMenu
    showVerticalMenu = true
    showBurger = false
    mobileClickCounter = 0
  }

  function hideMobileMenu() {
    //alert("Hide the verticle menu for mobile devices")
    showVerticalMenu = false
    showBurger = true
    mobileClickCounter = 0
    backToTop()
  }

  document.addEventListener("click", function () {
    // console.log("@ Nav: got a click!")
    if (
      showBurger == false &&
      showVerticalMenu == true &&
      mobileClickCounter == 0
    ) {
      mobileClickCounter++
      // console.log(
      //   "@ Nav: verticle menu shown with mobileClickCount = ",
      //   mobileClickCounter
      // )
    } else if (
      showBurger == false &&
      showVerticalMenu == true &&
      mobileClickCounter != 0
    ) {
      // console.log("@ Nav: to close verticle menu!")
      hideMobileMenu()
    }
  })

  function backToTop() {
    // Auto scroll back to the top of the page
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }

  function handleForgetPassword() {
    // console.log("@ Nav: handle forget password...")
    const modal = document.querySelector("#modal-login")
    M.Modal.getInstance(modal).close()
  }

  function startResetPassword(email) {
    // console.log("@ Nav: start resetting password...")

    const modal = document.querySelector("#modal-forget-password")
    M.Modal.getInstance(modal).close()

    // Admin SDK API to generate the password reset link.
    const userEmail = email
    alert("Got userEmail = " + userEmail)

    auth
      .sendPasswordResetEmail(userEmail)
      .then(function () {
        // console.log("Password reset email has been sent to " + userEmail)
        alert("Password reset email has been sent to " + userEmail)
      })
      .catch(function (error) {
        let errorCode = error.code
        let errorMsg = error.message
        // console.log("Something went wrong with ", errorCode)
        // console.log("Something went wrong with ", errorMsg)
        alert("Something went wrong with ", errorCode)
        alert("Something went wrong with ", errorMsg)
      })
    // admin
    //   .auth()
    // auth
    //   .generatePasswordResetLink(userEmail, actionCodeSettings)
    //   .then((link) => {
    //     // Construct password reset email template, embed the link and send
    //     // using custom SMTP server.
    //     return sendCustomPasswordResetEmail(email, displayName, link)
    //   })
    //   .catch((error) => {
    //     // Some error occurred.
    //     console.log(error)
    //     alert("Somethig is wrong! ", error)
    //   })

    alert("Please check your email for the password reset link!")
  }
</script>

<div class="navbar-fixed">
  <nav class="white" role="navigation">
    <div class="nav-wrapper container">
      <a on:click={backToTop} href="/" class=""
        ><img
          class="logo brand-logo"
          src="./images/xiyi-logo.png"
          alt="code"
        /></a
      >

      <ul id="nav-items" class="right">
        <!-- <div class="right" id="menu" on:click={showMobileMenu}> -->
        <div
          class={showBurger ? "right" : "hide"}
          id="menu"
          on:click={showMobileMenu}
        >
          <div class="burger" />
          <div class="burger" />
          <div class="burger" />
        </div>

        <div
          class={showVerticalMenu ? "vertical-menu" : "hide-on-med-and-down"}
        >
          <li style="display: block;">
            <label class="switch center indigo-text indigo lighten-5">
              <input
                type="checkbox"
                bind:checked={toggleChineseStyle}
                on:click={hideMobileMenu}
              />
              繁體<img
                class="swap "
                src="/images/swap_horiz-24px.svg"
                alt="Guest navbar"
              />简体
            </label>
          </li>
          <!-- <li
            class="logged-out"
            style="display: {showLoggedInElements ? 'none' : 'block'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/demo"
              >{$selectedLanguage == "TW" ? "使用示範" : "使用示范"}</a
            >
          </li> -->
          <li style="display: block;">
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/books">古籍</a
            >
          </li>
          <li
            class="logged-in"
            style="display: {showLoggedInElements ? 'block' : 'none'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/play">玩卦</a
            >
          </li>
          <li
            class="logged-in"
            style="display: {showLoggedInElements ? 'block' : 'none'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/qi">起卦</a
            >
          </li>
          <li
            class="logged-in"
            style="display: {showLoggedInElements ? 'block' : 'none'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/records">卦例</a
            >
          </li>
          <!-- <li
            class="logged-in"
            style="display: {showLoggedInElements ? 'block' : 'none'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/notes">消息更新</a
            >
          </li> -->
          <!-- <li style="display: block;">
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/about">{$selectedLanguage == "TW" ? "關於" : "关于"}</a
            >
          </li> -->
          <!-- <li class="logged-out" style="display: {isLogin ? 'none' : 'block'};">
            <a
              on:click={hideMobileMenu}
              href="/account"
              class="va indigo-text darken-4 modal-trigger"
              data-target="modal-signup"
              >{$selectedLanguage == "TW" ? "註冊" : "注册"}</a
            >
          </li> -->
          <li class="logged-out" style="display: {isLogin ? 'none' : 'block'};">
            <a
              on:click={hideMobileMenu}
              href="/login"
              class="va indigo-text darken-4 modal-trigger"
              data-target="modal-login">登入</a
            >
          </li>
          <li class="logged-in" style="display: {isLogin ? 'block' : 'none'};">
            <a
              on:click={hideMobileMenu}
              class="va indigo-text darken-4"
              href="/account">{$selectedLanguage == "TW" ? "帳戶" : "帐户"}</a
            >
          </li>
          <li
            class="logged-in"
            style="display: {showLoggedInElements && isAdmin
              ? 'block'
              : 'none'};"
          >
            <a
              on:click={hideMobileMenu}
              class="va red-text darken-4"
              href="/xiyiadmin">管理 Admin</a
            >
          </li>
          <li class="logged-in" style="display: {isLogin ? 'block' : 'none'};">
            <a
              on:click={hideMobileMenu}
              href="/"
              class="va indigo-text darken-4"
              id="logout"
              on:click={handleLogout}>登出</a
            >
          </li>
        </div>
      </ul>
    </div>
  </nav>
</div>

<!-- SIGN UP MODAL -->
<div id="modal-signup" class="modal big-signup">
  <div class="modal-content">
    <h4>註冊</h4>
    <form id="signup-form" on:submit|preventDefault={handleSignup}>
      <div class="input-field">
        <input
          type="text"
          id="signup-userName"
          bind:value={userName}
          autocomplete="section-blue userName"
          required
        />
        <label for="signup-userName">* 您的姓名</label>
      </div>
      <!-- <div class="input-field">
        <input
          type="text"
          id="signup-userAlias"
          bind:value={userAlias}
          placeholder={userName}
          autocomplete="section-blue userAlias"
          required
        />
        <label for="signup-userAlias">您的代號</label>
      </div> -->
      <div class="input-field">
        <input
          type="email"
          id="signup-email"
          bind:value={email}
          autocomplete="section-blue email"
        />
        <label for="signup-email">* Email （您必須能在此信箱受到郵件。）</label>
      </div>
      <div class="input-field">
        {#if showPasswd == true}
          <input
            type="text"
            id="signup-password"
            bind:value={password}
            autocomplete="section-blue current-password"
            required
          />
        {:else}
          <input
            type="password"
            id="signup-password"
            bind:value={password}
            autocomplete="section-blue current-password"
            required
          />
        {/if}
        <label for="signup-password">* 密碼 （至少六位）</label>
      </div>

      <div class="input-field">
        {#if showPasswd == true}
          <input
            class={dangerFieldClass}
            type="text"
            id="signup-confirmPassword"
            bind:value={confirmPassword}
            autocomplete="section-blue current-confirmPassword"
            required
          />
        {:else}
          <input
            class={dangerFieldClass}
            type="password"
            id="signup-confirmPassword"
            bind:value={confirmPassword}
            autocomplete="section-blue current-confirmPassword"
            required
          />
        {/if}
        <label for="signup-confirmPassword">* 確認密碼</label>
      </div>
      <div class="input-field">
        <p>
          <label>
            <input type="checkbox" bind:checked={showPasswd} />
            <span>展現密碼</span>
          </label>
        </p>
      </div>
      <div class="input-field">
        <input
          type="text"
          id="signup-country"
          bind:value={country}
          autocomplete="section-blue country"
        />
        <label for="signup-country">所在國家/地區</label>
      </div>
      <div class="input-field">
        <input
          type="text"
          id="signup-city"
          bind:value={city}
          autocomplete="section-blue city"
        />
        <label for="signup-city">所在城市</label>
      </div>
      <!-- <div class="input-field">
        <input
          type="text"
          id="signup-phone"
          bind:value={phone}
          autocomplete="section-blue phone"
        />
        <label for="signup-phone">電話 ☎️</label>
      </div>
      <div class="input-field-with-default">
        <label for="signup-goal">每月起卦目標</label>
        <input
          type="number"
          id="signup-goal"
          bind:value={qiMonthlyGoal}
          autocomplete="section-blue goal"
        />
      </div> -->
      <button class="btn light-green darken-3 z-depth-0">註冊 - Sign up</button>
    </form>
  </div>
</div>

<!-- LOGIN MODAL -->
<div id="modal-login" class="modal">
  <div class="modal-content">
    <h4>登入【XiYi習易網】</h4>
    <br />
    <!-- <form id="login-form" on:submit|preventDefault={handleLogin}> -->
    <form action="">
      <div class="input-field">
        <input type="email" id="login-email" bind:value={email} required />
        <label for="login-email">您的電子郵件信箱 - Email address</label>
      </div>
      <div class="input-field">
        <input
          type="password"
          id="login-password"
          bind:value={password}
          autocomplete="section-blue current-password"
          required
        />
        <label for="login-password">您的密碼 - Your password</label>
      </div>
      <div class="btn-row">
        <button
          class="btn-single btn blue darken-2 z-depth-0"
          on:click|preventDefault={handleLogin}>登入 - Log in</button
        >
        <a
          on:click={handleForgetPassword}
          href="/"
          class="btn-single btn red lighten-1 z-depth-0 modal-trigger "
          data-target="modal-forget-password">密碼忘了 - Forget Password</a
        >
      </div>
    </form>
  </div>
</div>

<!-- FORGET PASSWORD MODAL -->
<div id="modal-forget-password" class="modal">
  <div class="modal-content">
    <h4>重設密碼</h4>
    <br />
    <form action="">
      <div class="input-field-passwd">
        <label for="login-email">您的電子郵件信箱 - Email address</label>
        <input
          type="email"
          id="reset-password-email"
          bind:value={email}
          required
        />
      </div>

      <button
        class="btn-single btn blue darken-2 z-depth-0"
        on:click|preventDefault={() => startResetPassword(email)}
        >我要重設密碼 - Reset Password</button
      >
    </form>
  </div>
</div>

<style>
  @media screen and (max-width: 992px) {
    .container {
      /* background-color: rgb(229, 231, 100); */
    }
    nav .brand-logo {
      left: 12%;
    }
    .hide-on-med-and-down {
      display: none !important;

      /* display: inline !important; */
    }
    nav ul li {
      padding-top: 20px;
    }

    #nav-items .mobile-group {
      /* display: flex; */
      justify-content: space-around;
      align-items: center;
      margin: 0;
    }

    #menu {
      margin-top: 15px !important;
    }

    #menu:hover {
      cursor: pointer;
    }

    .burger {
      width: 35px;
      height: 5px;
      background-color: #333333;
      margin: 6px 0;
    }

    /* Vertical menu */
    .vertical-menu {
      display: grid;
      grid-template-columns: 1fr;
      background-color: #cce;
      width: 150px;
      /* margin-top: 65px !important; */
      float: right;
    }

    .vertical-menu li {
      padding: 0;
    }
    .vertical-menu li a {
      /* background-color: #559; */
      color: black;
      /* display: block; */
      /* padding: 5px; */
      text-decoration: none;
      line-height: 50px;
    }

    .vertical-menu li a:hover {
      background-color: #aad;
      cursor: pointer;
    }

    /* .vertical-menu a.active {
      background-color: #4caf50;
      color: white;
    } */
  }

  .big-signup {
    /* max-height: 100%; */
    overflow-y: auto;
  }

  .danger-field {
    border-color: red;
  }

  .logo {
    margin-top: 5px;
    width: 120px;
    height: 50px;
  }
  .btn-single {
    margin-bottom: 15px;
  }
  .btn-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .switch {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
    margin-right: 10px;
    padding: 3px 5px;
    border: solid #7986cb 1px;
    border-radius: 5px;
    vertical-align: middle;
    margin-top: 22px;
    height: 24px;
    width: 90px;
  }
  .switch:hover {
    cursor: pointer;
  }
  /* .swap {
    
  } */
</style>
